import React from 'react'
import { useSelectedCardTabStore } from 'store'
import { Tab } from '@headlessui/react'
import WORDING from 'constants/wording'

import CustomHeadlessTabs from 'components/CustomHeadlessTabs'
import VirtualCardTab from './VirtualCardTab'
import PhysicalCardTab from './PhysicalCardTab'

const { VIRTUAL, PHYSICAL } = WORDING

// TAB CUSTOM COMPONENT SHOULD BE EQUAL TO
// THE MORE POLISHED ONE IN TURBOREPO

const CardTabs = () => {
  const { typeCard, updateTypeCard } = useSelectedCardTabStore()

  return (
    <Tab.Group
      defaultIndex={typeCard === 'PHYSICAL' ? 1 : 0}
      onChange={(index) => updateTypeCard(index === 1 ? 'PHYSICAL' : 'VIRTUAL')}
    >
      <CustomHeadlessTabs className='mt-5' tabs={[VIRTUAL, PHYSICAL]} />
      <Tab.Panels className='!min-h-[55vh] w-full transition-all duration-200'>
        <Tab.Panel className='p-1 min-h-[50vh]'>
          <VirtualCardTab />
        </Tab.Panel>
        <Tab.Panel className='p-1 w-full'>
          <PhysicalCardTab />
        </Tab.Panel>
      </Tab.Panels>
    </Tab.Group>
  )
}

export default CardTabs
